import { AuthConfig, HttpInterceptorConfig } from '@auth0/auth0-angular'

import { IEnvironment, IEnvState } from '~/core/models'

const ssrApiUrl = 'https://stocks.proximilar.com/api/v1'

export const ENV: IEnvironment = {
  appVersion: require('../../package.json').version,
  production: true,
  allowNgrxDebug: false,
  env: 'prod',
  ssrApiUrl,
}

export const DEFAULT_ENV: IEnvState = {}

const apiUrl = '/api/v1'

export const AUTH0_INTERCEPTOR: HttpInterceptorConfig = {
  allowedList: [
    `${apiUrl}/user-info`,
    {
      uri: `${apiUrl}/*`,
      allowAnonymous: true,
    },
  ],
}

export const AUTH0_CONFIG: AuthConfig = {
  domain: 'proximilar.us.auth0.com',
  clientId: '99WRVzoCzsFUsa2Enjxi161hdES1DT4R',
  cacheLocation: 'localstorage',
  authorizationParams: {
    audience: 'https://stocks.proximilar.com/api/v1',
    redirectUri: 'https://stocks.proximilar.com',
    redirect_uri: 'https://stocks.proximilar.com',
  },
  httpInterceptor: {
    ...AUTH0_INTERCEPTOR,
  },
}
